import '../util/Waypoints';

export default {
  init() {
		// JavaScript to be fired on all pages

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

     /**
		 * Mobile Menu Toggler
		 */
		$('button.hamburger').on('click', function(){
			$(this).toggleClass('is-active');
			$('body, .nav-primary').toggleClass('nav-open');
		});

		/**
		 * Define SEO friendly method for multiple links to same dest.
		 * Example : <div class="link_master"><a href="#" class="link">MAIN LINK</a><img class="link_slave" /></div>
		 */
		$('body').on('click', '.link-slave', function(){
				var $master 	= $(this).parents('.link-master');
				var $reallink = $($master).find('a.link');
				$reallink[0].click();
		});

    /* Modal Interactions */
    $('body').on('click', '.modal-open', function(e){
      e.preventDefault();
      var id = $(this).attr("href");
      $(id).addClass('is-active');
      $('html').addClass('is-clipped');
    });
    $('body').on('click', '.modal-close, .modal-background', function(){
      $('.modal').removeClass('is-active');
      $('html').removeClass('is-clipped');
    });

    /**
		 * Animated KPI
		 * Increment number defined in widget Animated KPI
		 */
		var t = "1";
		$(".stats-number .number").text(t), $(".stats-number .number").waypoint(function () {
			$(".stats-number .number").each(function () {
				var t = $(this);
				$({
					Counter: 1,
				}).animate({
					Counter: t.attr("data-stop"),
				}, {
					duration: 3000,
					easing: "swing",
					step: function (a) {
						t.text(Math.ceil(a))
					},
				})
			}), this.destroy()
		}, {
			offset: "95%",
		});

    /* Sharer Widget */
    $('a.click_social').on('click', function(){
      window.open($(this).attr('href'), '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
      return false;
    });

    /**
     * Init LightSliders
     * (Only if has more than one slide)
     */
    $('.page-header-slider').each(function(){
      if($(this).find('li').length > 1){
        $(this).lightSlider({
          item:1,
          loop:true,
          mode:'fade',
          easing: 'ease-in-out',
          speed:800,
          auto:true,
          pauseOnHover:true,
          pause:5000,
          keyPress:true,
          currentPagerPosition:'right',
        });
      }
    });

    $('.timeline-slider').lightSlider({
      item:3,
      slideMove:2,
      loop:false,
      slideMargin:30,
      mode:'slide',
      easing: 'ease-in-out',
      speed:800,
      auto:true,
      pager: false,
      pauseOnHover:true,
      pause:5000,
      keyPress:true,
      currentPagerPosition:'right',
      responsive : [
          {
              breakpoint:800,
              settings: {
                  item:2,
                  slideMove:2,
                },
          },
          {
              breakpoint:480,
              settings: {
                  item:1,
                  slideMove:1,
                },
          },
      ],
    });


    /* FAQs */
    $('.entry-faq .entry-header a').on('click', function(e){
      e.preventDefault();
      var id = $(this).attr('href');
      $(this).toggleClass('active');
      $(id + ' .entry-content').slideToggle();
    });


    /* Process Steps */
    if($('.steps-process-widget').length){
      steps_process_history();
      window.onhashchange = function() {
        steps_process_history();
      }
    }
    function steps_process_history(){
      var hash = window.location.hash.substr(1);
      if(hash){
        var tmp = hash.split('-');
        if( $('#'+tmp[0]).length ){
          $('.steps-process-widget .steps_home').hide();
          if(tmp[1] && tmp[1] != 1){
            $('#'+tmp[0] + ' .step_1').css('display','none');
            $('#'+tmp[0] + ' .'+tmp[1]).css('display','table');
            $('#'+tmp[0]).fadeIn();
          }
          else{
            $('#'+tmp[0] + ' .step_right').css('display','none');
            $('#'+tmp[0] + ' .step_1').css('display','table');
            $('#'+tmp[0]).fadeIn();
          }
        }
      }
      else{
        $('.steps-process-widget .steps_content').hide();
        $('.steps-process-widget .steps_home').fadeIn();
      }
    }
    $('.steps-process-widget .steps_home a.button').on('click', function(e){
      e.preventDefault();
      var section = $(this).attr('href');
      $('.steps-process-widget .steps_home').hide();
      history.pushState('', '', section);
      $(section + ' .step_right').css('display','none');
      $(section + ' .step_1').css('display','table');
      $(section).fadeIn();
      if(window.innerWidth < 768){
        var target_offset = $(section+' .step_1').offset();
        var target_top = target_offset.top-66;
        $('html, body').animate({scrollTop:target_top}, 500, 'easeInSine');
      }
    });
    $('.steps-process-widget .steps_content a.prev_step').on('click', function(){
      var section = $(this).parents('.steps_content').attr('id');
      var current_step = parseInt($(this).parents('.step').attr('data-id'));
      $(this).parents('.step').hide();
      window.history.go(-1);

      if(current_step > 1){
          history.pushState('', '', '#'+section+'-step_'+(current_step-1));
          $('.steps-process-widget .steps_content .step_' + (current_step-1) ).fadeIn().css('display','table');
      }
      else{
        history.pushState('', '', ' ');
        $('.steps-process-widget .steps_content').hide();
        $('.steps-process-widget .steps_home').fadeIn();
      }
    });
    $('.steps-process-widget .steps_content a.next_step').on('click', function(){
      var section = $(this).parents('.steps_content').attr('id');
      var current_step = parseInt($(this).parents('.step').attr('data-id'));
      $(this).parents('.step').hide();
      history.pushState('', '', '#'+section+'-step_'+(current_step+1));
      $('.steps-process-widget .steps_content .step_' + (current_step+1) ).fadeIn().css('display','table');
      if(window.innerWidth < 768){
        var target_offset = $("#"+section+' .step_'+(current_step+1)).offset();
        var target_top = target_offset.top-66;
        $('html, body').animate({scrollTop:target_top}, 500, 'easeInSine');
      }

    });



  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js